import React from 'react';
import { Form } from '@ant-design/compatible';

import ProductDetailPanel from '../../ProductDetailPanel';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import BaseForm from '../../../../../components/form/BaseForm';
import SelectForm from '../../../../../components/form/SelectForm';
import useSelectBrandMutate from '../../../../../hooks/queries/product/useSelectBrandMutate';
import { formRequiredRules } from '../../../../../lib/formRules';
import {
  ENABLE_CHANGE_PRODUCT_STATUS_SELECT_LIST,
  PRODUCT_COPY_ENABLE_CHANGE_PRODUCT_STATUS_SELECT_LIST,
  PRODUCT_DETAIL_PAGE_PANEL_NAME,
  PRODUCT_DETAIL_PAGE_TYPE,
  PRODUCT_STATUS_SELECT_LIST,
} from '../../../../../constants/service/app/productConstants';
import { REQUIRED_MSG } from '../../../../../constants/service/common/formRulesConstants';
import './ProductStatusAndBrandInfo.scss';

const ProductStatusAndBrandInfo = (props) => {
  const { pageType, form, initialValue, storeSelectList } = props;
  const { status, brandName, storeId, enableStatus } = initialValue;
  const selectBrandMutate = useSelectBrandMutate(form);

  /**
   *  등록/복사 페이지인 경우
   */
  const isCreatePage = pageType === PRODUCT_DETAIL_PAGE_TYPE.CREATE;

  /**
   *  상세 페이지인 경우
   */
  const isDetailPage = pageType === PRODUCT_DETAIL_PAGE_TYPE.DETAIL;

  /**
   *  상품 상태 변경 SELECT 리스트
   */
  let productStatusSelectList = null;
  if (pageType === PRODUCT_DETAIL_PAGE_TYPE.EDIT && enableStatus) {
    productStatusSelectList = ENABLE_CHANGE_PRODUCT_STATUS_SELECT_LIST;
  } else if (pageType === PRODUCT_DETAIL_PAGE_TYPE.COPY && enableStatus) {
    productStatusSelectList = PRODUCT_COPY_ENABLE_CHANGE_PRODUCT_STATUS_SELECT_LIST;
  } else productStatusSelectList = PRODUCT_STATUS_SELECT_LIST;

  return (
    <ProductDetailPanel
      name={PRODUCT_DETAIL_PAGE_PANEL_NAME.PRO_STATUS_AND_BRAND_INFO}
      className="product-status-and-brand-info"
      title="상품 상태 및 브랜드 정보"
    >
      <div className="panel-body">
        {/* 상품 상태*/}
        {/* [상품 등록]시에는 선택하지 못하도록 합니다.*/}
        {/* [상품 편집]시에 상품 상태가  2(판매중), 3(품절), 7(판매 중지)인 경우에만 상태를 변경할 수 있도록 함*/}
        <SelectForm
          form={form}
          label="상품 상태 변경"
          disabled={isCreatePage || isDetailPage || !enableStatus}
          isTable
          initialValue={status}
          list={productStatusSelectList}
          name="status"
          subContent={
            isCreatePage && (
              <div className="sub-info">
                <div>*상품 등록 시에는 승인 대기 상태로 저장이 됩니다.</div>
              </div>
            )
          }
        />

        {/* 브랜드명*/}
        {!isCreatePage ? (
          <Form.Item>
            {form.getFieldDecorator('storeId', {
              initialValue: storeId,
            })(<BaseForm label="브랜드명" content={<OpenBrandDetail text={brandName} storeId={storeId} />} />)}
          </Form.Item>
        ) : (
          <SelectForm
            label="브랜드명"
            form={form}
            rules={[formRequiredRules(true, REQUIRED_MSG, false)]}
            isTable
            showSearch
            optionFilterProp="children"
            initialValue={storeId}
            onChange={(storeId) => selectBrandMutate.mutate(storeId)}
            list={storeSelectList}
            name="storeId"
          />
        )}
      </div>
    </ProductDetailPanel>
  );
};

export default ProductStatusAndBrandInfo;
